import { ToggleButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { EventStatusTabKeysEnum } from 'src/shared/models/enums/eventStatus.enum';
import { EventStatusTabItem, eventTabs } from './eventStatusTabs';

const limitedEventTabs = eventTabs.filter((x) => x.key !== 'active');

type EventOverviewStatusesProps = {
  initialValue: EventStatusTabKeysEnum[];
  callback: (statuses: EventStatusTabItem[]) => void;
};

export const EventOverviewStatuses = (props: EventOverviewStatusesProps) => {
  const { initialValue, callback } = props;

  const { t } = useTranslation();

  const [selectedKeys, setSelectedKeys] = useState<string[]>(
    initialValue && initialValue.length ? initialValue : [EventStatusTabKeysEnum.Upcoming, EventStatusTabKeysEnum.Completed],
  );

  const handleKeys = (event: React.MouseEvent<HTMLElement>, newKeys: string[]) => {
    const selected = limitedEventTabs.filter((item) => newKeys.includes(item.key));
    setSelectedKeys(newKeys);
    callback(selected || []);
  };

  return (
    <FormFieldset legend={t('member:memberAdvancedSearch.status')} noPadding>
      <StyledToggleButtonGroup value={selectedKeys} onChange={handleKeys} color='primary' size='small'>
        {limitedEventTabs.map((x) => (
          <ToggleButton value={x.key} key={x.key}>
            {t(x.label)}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
